import { allowedSearchCharactersRegex } from 'features/common/validations/matchers';
import { useDebounce } from 'features/common/hooks/useDebounce';
import { useCallback, useState } from 'react';

export const useGroupMembersSearch = () => {
  const [searchFilter, setSearchFilter] = useState('');
  const [isValid, setIsValid] = useState(true);
  const debouncedSearch = useDebounce(searchFilter);

  const onSearchChange = useCallback((value: string) => {
    if (allowedSearchCharactersRegex.test(value)) {
      setSearchFilter(value);
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, []);

  const clearSearch = useCallback(() => {
    setSearchFilter('');
    setIsValid(true);
  }, []);

  return {
    searchFilter,
    onSearchChange,
    clearSearch,
    isValid,
    debouncedSearch,
  };
};
